import { render } from "./Ankete.vue?vue&type=template&id=4b118ace&scoped=true"
import script from "./Ankete.vue?vue&type=script&lang=js"
export * from "./Ankete.vue?vue&type=script&lang=js"

import "./Ankete.vue?vue&type=style&index=0&id=4b118ace&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b118ace"]])

export default __exports__